<template>
    <header class="header-warpper">
        <div class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <router-link to="/" class="navbar-brand"><img src="@/assets/images/logo.png" alt="logo"></router-link>
                </div>
                <div class="col-6">
                    <div class="my-account-dd" v-if="$route.path !== '/login'">
                        <div class="dropdown dropstart">
                            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <span>My Account</span> <i class="bi bi-chevron-down"></i>
                            </button>
                            <ul class="dropdown-menu user-img-sec-list" aria-labelledby="dropdownMenuButton1">
                                <li class="setting-icon" v-if="user">
                                    <a href="#">
                                        <i class="fa fa-user"></i>
                                        <span class="user-name">{{ user.name }}({{ user.userid }})</span>
                                    </a>
                                </li>
                                <li class="setting-icon" v-if="user">
                                    <a href="#manage-global-commission-modal" data-bs-toggle="modal">
                                        <i class="fa fa-user"></i>
                                        <span class="user-name">Manage Commission</span>
                                    </a>
                                </li>
                                 <li>
                                    <a href="#change-password" data-bs-toggle="modal">
                                        <i class="fa fa-lock"></i>
                                        <span class="change-password">Change Password</span>
                                    </a>
                                </li>
                                <li>
                                    <a @click="logout()">
                                        <i class="fa fa-sign-out"></i>
                                        <span class="log-out">Log out</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade cmn-modal add-new-team-modal" id="manage-global-commission-modal" data-bs-backdrop="static" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="user">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h5 class="modal-title">Manage Global Commission</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="reset_form()"></button>
                        </div>
                        <div class="modal-body">
                            <ul class="error-messages" v-if="error_message">
                                <li class="text-danger" v-for="(err, index) in error_message" :key="index">
                                    {{ err }}
                                </li>
                            </ul>
                            <div class="cmn-form">
                                <div class="mb-3">
                                    <label class="form-label">Bet With Team:</label>
                                    <input type="number" class="form-control" v-model="commission.team">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Bet With Run:</label>
                                    <input type="number" class="form-control" v-model="commission.run">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Bet With Ball:</label>
                                    <input type="number" class="form-control" v-model="commission.ball">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="reset_form()">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="save_commission()">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade cmn-modal add-new-team-modal" id="change-password" data-bs-backdrop="static" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="user">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h5 class="modal-title">Change Password</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="reset_form()"></button>
                        </div>
                        <div class="modal-body">
                            <ul class="error-messages" v-if="error_message">
                                <li class="text-danger" v-for="(err, index) in error_message" :key="index">
                                    {{ err }}
                                </li>
                            </ul>
                            <div class="cmn-form">
                                <div class="mb-3">
                                    <label class="form-label">New Password:</label>
                                    <input type="password" class="form-control" placeholder="Enter new passord" v-model="changePassword.password">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Confirm New Password:</label>
                                    <input type="password" class="form-control" placeholder="Enter new confirm passord" v-model="changePassword.confirm_password">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="reset_form()">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="change_password()">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { Modal } from "bootstrap"
export default {
    data() {
        return {
            error_message: [],
            user:{},
            commission: {
                team: null,
                run: null,
                ball: null,
            },
            old_commission: {
                team: null,
                run: null,
                ball: null,
            },
            commission_Modal: '',
            password_Modal: '',
            changePassword: {
				password: null,
				confirm_password: null,
			}
        }
    },
    created(){
        this.user=JSON.parse(localStorage.getItem('authData'))
        this.old_commission=JSON.parse(localStorage.getItem('global_commission'))
        this.commission=JSON.parse(localStorage.getItem('global_commission'))
        if(!this.old_commission) {
            this.old_commission = { team: null, run: null, ball: null }
            this.commission = { team: null, run: null, ball: null }
        }
    },
    mounted() {
        if(this.user) {
            this.commission_Modal = new Modal(document.getElementById('manage-global-commission-modal'), {
                keyboard: false
            });
            this.password_Modal = new Modal(document.getElementById('change-password'), {
                keyboard: false
            });
        }
    },
    methods: {
        logout() {
            axios.post('logout').then(res => {
                localStorage.removeItem('_token');
                localStorage.removeItem('authData');
                localStorage.removeItem('global_commission');
                this.$router.push('/login')
            })
        },
        save_commission() {
            if(JSON.stringify(this.old_commission) === JSON.stringify(this.commission)) {
                this.$toast.warning("Nothing to change!");
            } else {
                this.$store.commit('is_loader', true); 
                axios.post('save-global-commission', this.commission).then(res => {
                    if (res.data.error === true) {
                        this.$toast.error(res.data.message);
                    } else {
                        this.$toast.success(res.data.message);
                        localStorage.setItem('global_commission',JSON.stringify(this.commission));
                        this.old_commission = Object.assign({}, this.commission)
                        this.commission_Modal.hide()
                    }
                    this.$store.commit('is_loader', false);
                }).catch(e => {
                    console.error(e)
                })
            }
        },
        change_password() {
            if (!this.changePassword.password || this.changePassword.password.length < 6) {
                this.$toast.warning("Password is required and must be at least 6 characters");
                return;
            }
            if (this.changePassword.password !== this.changePassword.confirm_password) {
                this.$toast.warning("Passwords do not match");
                return;
            }
            axios.post('/change-password', {
                password: this.changePassword.password,
                password_confirmation: this.changePassword.confirm_password
            }).then(res => {
                if (res.data.error === true) {
                    if(res.data.data.confirm_password)
                    {
                         this.$toast.error(res.data.data.confirm_password);
                    }
                    else if(res.data.data.password)
                    {
                        this.$toast.error(res.data.data.password);
                    }
                    else
                    {
                    this.$toast.error(res.data.message);
                    }
                }else {
                        this.$toast.success(res.data.data);
                        this.password_Modal.hide();
                        this.reset_form();
                    }
                }).catch(e => {
                console.error(e)
                this.$toast.error(e.response.data.message);
            });

        },
        reset_form() {
            this.commission=JSON.parse(localStorage.getItem('global_commission'))
            if(!this.commission) {
                this.commission = { team: null, run: null, ball: null }
            }
            this.changePassword = {
                password: '',
                confirm_password: ''
            };
        }
    }
}
</script>
<style scoped>
.user-name{
    margin-left: 3px;
}
.log-out{
    cursor: pointer;
    margin-left: 3px;
}

</style>

